import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { CampaignWorkspaceRoutingModule } from './campaign-workspace-routing.module';
import { IndexComponent } from './index/index.component';
import { WorkspaceDashboardComponent } from './workspace-dashboard/workspace-dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CampaignDriveComponent } from './campaign-drive/campaign-drive.component';
import { AuthService } from '../shared/services/auth.service';
import { WorkspaceCreationGuard } from '../workspace/guards/workspace-creation.guard';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from '../sub-modules/SharedModule';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProjectsComponent } from './projects/projects.component';
import { TimelineSimulatorComponent } from './timeline-generator/timeline-simulator/timeline-simulator.component';
import { MtmCampaignProjectsComponent } from './campaign-drive-dashboard/overview/mtm-campaign-projects/mtm-campaign-projects.component';
import { TimelineSharedModule } from './timeline-generator/timeline-shared.module';
import { TimelineSimulatorCriteriaForm2Component } from './timeline-generator/timeline-simulator/timeline-simulator-criteria-form2/timeline-simulator-criteria-form2.component';
import { PlatformCommentsChatModule } from '../shared/components/platform-comments-chat/platform-comments-chat.module';
import { StatusSelectComponent } from '../shared/components/status-select/status-select.component';
import { LoadingSpinnerComponent } from '../shared/components/loading-spinner/loading-spinner.component';
@NgModule({
  declarations: [
    IndexComponent,
    WorkspaceDashboardComponent,
    CampaignDriveComponent,
    ProjectsComponent,
    MtmCampaignProjectsComponent,
    TimelineSimulatorComponent,
    TimelineSimulatorCriteriaForm2Component,
  ],
  imports: [
    CommonModule,
    CampaignWorkspaceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    SharedModule,
    NgbDropdownModule,
    NgbModule,
    TimelineSharedModule,
    PlatformCommentsChatModule,
    NgOptimizedImage,
    StatusSelectComponent,
    LoadingSpinnerComponent,
  ],
  exports: [MtmCampaignProjectsComponent, TimelineSimulatorComponent, TimelineSimulatorCriteriaForm2Component],
  providers: [AuthService, WorkspaceCreationGuard],
})
export class CampaignWorkspaceModule {}
